import { useTheme } from '../../context/ThemeContext';

const LoadingScreen = ({ message = 'Loading...' }) => {
  const { theme } = useTheme();
  return (
    <div className="loading-page">
      <div style={{ textAlign: 'center' }}>
        <div style={{
          fontFamily: "'Baloo 2', cursive",
          fontSize: '22px',
          fontWeight: 800,
          color: 'var(--brand-primary)',
          marginBottom: '20px'
        }}>
          {theme.logoUrl
            ? <img src={theme.logoUrl} alt="MyPersonalGuruji" style={{ height: '40px' }} />
            : 'MyPersonalGuruji'
          }
        </div>
        <div className="spinner" style={{ width: '32px', height: '32px', margin: '0 auto 12px' }}></div>
        <p style={{ fontSize: '12px', color: 'var(--muted)', fontWeight: 600 }}>{message}</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
